import { Box, ChevronRightIcon } from '@deckee/deck-hand';
import React, { FC, type KeyboardEvent } from 'react';
import styled, { useTheme } from 'styled-components';
import usePaywall from '../../../../hooks/use-paywall';
import { trackExtendedForecastDayListCtaTapped } from '../../helpers/analytics/extendedForecastAnalytics';

const ChipButton = styled(Box)`
  flex: 0 0 auto;
  gap: 16px;
  height: 64px;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
`;

export interface ExtendedForecastCtaChipProps {
  onActivate: (callback: () => void) => void;
}

const ExtendedForecastCtaChip: FC<ExtendedForecastCtaChipProps> = ({
  onActivate,
}) => {
  const theme = useTheme();
  const { presentPaywall } = usePaywall('Extended weather forecast');

  const openPaywall = () => {
    trackExtendedForecastDayListCtaTapped();
    presentPaywall();
  };

  const handleActivate = () => {
    onActivate(openPaywall);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openPaywall();
    }
  };

  return (
    <ChipButton
      display="flex"
      alignItems="center"
      px={3}
      bg="primary"
      color="white"
      role="button"
      tabIndex={0}
      aria-label="Get 15 day boating forecasts"
      data-testid="weather-forecast-extended-cta-chip"
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
    >
      <Box flex="0 1 auto" pr={1}>
        <Box fontSize={1} fontWeight={700} lineHeight="1.2" color="white">
          Get 15 day boating forecasts
        </Box>
        <Box fontSize={1} fontWeight={400} lineHeight="1.2" color="white">
          Plan even further ahead
        </Box>
      </Box>
      <Box flex="0 0 auto" display="flex" alignItems="center">
        <ChevronRightIcon color={theme.colors.white} size={16} />
      </Box>
    </ChipButton>
  );
};

export default ExtendedForecastCtaChip;
